import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-form',
  imports: [FormsModule],
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})
export class FormComponent {
  private ssrService = inject(SsrService);
  @Input() color: 'default' | 'light' = 'default';
  @Input() gap: 'default' | 'small' = 'default';
  @Output() submited: EventEmitter<void> = new EventEmitter<void>();
  @Output() validated: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('form') form?: ElementRef;

  @HostListener('click', ['$event.target']) onClick(e: HTMLElement): void {
    if (e.closest('[data-validate]')) this.validate();
  }

  validate(): void {
    if (this.ssrService.isServer()) return;
    const form = this.form?.nativeElement;
    const inputs: HTMLElement[] = form.querySelectorAll('input[required], select[required], textarea[required], .make-model-single__button');
    for (let input of inputs) {
      input.focus();
      input.blur();
    }
    setTimeout(() => {
      const valid: boolean = form.querySelectorAll('app-input-error').length === 0;
      this.validated.emit(valid);
    });
  }

  submit(): void {
    this.validate();
    setTimeout(() => this.submited.emit());
  }
}
